import { UserType } from '@crema/models/account';
import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

const initialState: UserType = {
  id: 0,
  username: '',
  email: '',
  roles: [],
  activated: false,
};

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<UserType>) => {
      // Redux Toolkit allows us to write "mutating" logic in reducers. It
      // doesn't actually mutate the state because it uses the Immer library,
      // which detects changes to a "draft state" and produces a brand new
      // immutable state based off those changes
      const { id, username, email, roles, activated, langKey } = action.payload;

      state.id = id;
      state.username = username;
      state.email = email;
      state.roles = roles;
      state.activated = activated;
      state.langKey = langKey;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setUser } = userSlice.actions;

export default userSlice.reducer;
